import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import ErrorIcon from '@material-ui/icons/Error'
import WarningIcon from '@material-ui/icons/Warning'
import InfoIcon from '@material-ui/icons/Info'

/**
 * Single-action alert dialog used by alertDialog() + eventAlert() in
 * `app/helpers.js`. Replaces the SweetAlert2 popups whose buttons /
 * typography didn't match the rest of the Alfred portal.
 *
 * Variant icon comes from MUI's icon set so the look is consistent
 * with the modify-admission modal and other in-app dialogs.
 */
const ICON_BY_VARIANT = {
  success: { Icon: CheckCircleIcon, color: '#2e7d32' },
  error: { Icon: ErrorIcon, color: '#b8294a' },
  warning: { Icon: WarningIcon, color: 'rgba(242, 94, 53, 1)' },
  info: { Icon: InfoIcon, color: '#1976d2' },
}

const AlertDialog = ({
  open,
  variant = 'info',
  title,
  message,
  buttonText,
  onClose,
}) => {
  const meta = ICON_BY_VARIANT[variant] || ICON_BY_VARIANT.info
  const { Icon, color } = meta
  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs' fullWidth>
      {title ? <DialogTitle>{title}</DialogTitle> : null}
      <DialogContent>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
          {Icon ? (
            <Icon style={{ color, fontSize: 28, flexShrink: 0 }} />
          ) : null}
          <Typography
            variant='body1'
            style={{ whiteSpace: 'pre-line', flex: 1 }}
          >
            {message}
          </Typography>
        </div>
      </DialogContent>
      <DialogActions style={{ padding: '12px 24px 20px' }}>
        <Button
          onClick={onClose}
          color='primary'
          variant='contained'
          autoFocus
        >
          {buttonText || 'OK'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AlertDialog
